import { StateType } from 'data/types'

import { ConfigState } from './slice'
import { ApplicationConfig } from './types'

const get = (state: StateType): ConfigState => state.config

export const isFetching = (state: StateType) => get(state).fetching ?? false

export const hasError = (state: StateType) => get(state).hasError

const DEFAULT_CONFIG: ApplicationConfig = {
  checkAllowedAddresses: false,
  env: 'prod',
  maintenance: {
    duration: 1,
    time: '2021-08-25T22:00:00.000Z'
  },
  memoTokens: ['XLM', 'XRP'],
  native2FA: false,
  newCurrencies: [],
  newMarginPairs: [],
  nextCurrencyHalt: {
    XRP: '2021-01-07T23:59:00.000Z'
  },
  openBankingCallback: 'https://www.blockchain.com/brokerage-link-success',
  plaidSupported: false,
  recaptchaKey: '',
  referrals: false,
  settlementFlow: false,
  silverRemoval: true,
  takeProfitEnabled: false,
  walletUrl: 'https://login.blockchain.com'
}

export const getConfig = (state: StateType) => get(state).data ?? DEFAULT_CONFIG

export const hasConfig = (state: StateType) => !!get(state).data
